import { memo } from 'react';
import styles from './aboutPage.module.css';

export default memo(function AboutPage() {
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <h1 className={styles.title}>About</h1>
        <div className={styles.contentSection}>
          <div className={styles.imageContainer}>
            <img 
              src="/image.jpg" 
              alt="Autie Travel Founder" 
              className={styles.aboutImage}
            />
          </div>
          <div className={styles.textContent}>
            <p className={styles.aboutText}>
              Autie Travel was created by Sam Adams, a doctor in the San Francisco Bay Area who learned a few years ago that he is on the spectrum. This new information helped him understand quite a lot about his life - including why he often finds it highly stressful to find a comfortable hotel room when traveling.
            </p>
            <p className={styles.aboutText}>
              Most hotels focus on services, amenities, and fashionable, flashy designs - with no apparent regard at all for travelers with increased sensory awareness, either because those travelers are neurodivergent, or even just because they notice details more than average travelers. Sam observed that even some of the highest end brands were not always the most comfortable locations when considering sensory input - and that there did not seem to be a site where travelers could track and share this information.
            </p>
            <p className={styles.aboutText}>
              While engaging in his favorite pastime of hiking in the hills of northern California, Sam reflected quite a lot, and designed this site with the goal of creating a refuge that is kind, easy to use, streamlined, and created with respect and appreciation for similar fellow travels.
            </p>
            <p className={styles.aboutText}>
              His hope is also that by helping travelers find the most comfortable locations, hotels may begin to notice their sensory ratings, and refocus on making the experiences they offer more calm, quiet, and sensory-friendly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});
